import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Animals from './pages/Animals';
import Safari from './pages/Safari';
import Tickets from './pages/Tickets';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Nearby from './pages/Nearby';
import { Toaster } from './components/ui/toaster';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/safari" element={<Safari />} />
          <Route path="/animals" element={<Animals />} />
          <Route path="/tickets" element={<Tickets />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/nearby" element={<Nearby />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
